module.exports = __webpack_public_path__ + "static/media/logo-qubits.37085c5e.png";